import {
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { CompanyBlackListRepository } from '@/store/company-blacklist-state/company-blacklist-state.repository';
import { DecisionEnum } from '@/types';

interface IGetCompanySubmissionsBlackListDataTableObject {
  store: CompanyBlackListRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getCompanySubmissionsBlackListDataTableObject = ({
  store,
  createAction,
  rowActions,
}: IGetCompanySubmissionsBlackListDataTableObject): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.blackList.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const nifColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.blackList.table.nif',
    accessorKey: 'nif',
    variant: DataTableColumnVariant.TEXT,
  };

  const countryColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.blackList.table.country',
    accessorKey: 'pays',
    variant: DataTableColumnVariant.TEXT,
  };

  const decisionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.blackList.table.decision.label',
    accessorKey: 'natureDecision',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return { value: `settings.blackList.table.decision.${value}` };
    },
  };

  const effectDateColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.blackList.table.effectDate',
    accessorKey: 'dateEffet',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy',
    },
  };

  const deadlineColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'settings.blackList.table.deadline',
    accessorKey: 'delai',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy',
    },
  };
  return {
    singular: 'settings.blackList.table.singular',
    plural: 'settings.blackList.table.plural',
    variant: DataTableVariant.COMMON,
    columns: [idColumn, nameColumn, nifColumn, countryColumn, decisionColumn, effectDateColumn, deadlineColumn],
    stripedRows: true,
    sizes: [10, 20, 50],
    target: (row: any) => {
      store.setNested('selectedCompany', {
        code: row.societeId,
        name: row.nom,
      });
      store.setNested('selectedCompanyObject', {
        societeId: row.societeId,
        nom: row.nom,
        nif: row.nif,
        pays: row.pays,
      });
      store.setNested('dto', {
        id: row.id,
        societeId: row.societeId,
        delai: row.delai ? new Date(row.delai) : null,
        dateEffet: new Date(row.dateEffet),
        natureDecision:
          row.natureDecision === DecisionEnum.TEMPORAIRE
            ? { code: DecisionEnum.TEMPORAIRE, name: 'settings.blackList.table.temporary' }
            : { code: DecisionEnum.PERMANENT, name: 'settings.blackList.table.permanent' },
      });
    },
    createAction,
    rowActions,
    rowRenderOverride: (row: any) => {
      return {
        class: row.natureDecision === DecisionEnum.PERMANENT ? 'pointer-events-none opacity-70' : '',
      };
    },
  };
};
